import {EmptyList, EmptyListProps} from "@/components/placeholder/EmptyList.tsx";
import {EmptyListInfo, EmptyListInfoProps} from "@/components/placeholder/EmptyListInfo.tsx";

interface EmptyListViewProps extends Omit<EmptyListInfoProps, "className">, Omit<EmptyListProps, "className"> {}

export const EmptyListView = ({
  title,
  subtitle,
  helpImage,
  helpTitle,
  helpSubtitle,
  helpLinks,
  children,
}: EmptyListViewProps) => {
  return (
    <div className="white-block white-block-border mb-3">
      <div className="container mw-100">
        <div className="row p-3">
          <EmptyList className="col-lg-8 col-xl-9 mb-3" title={title} subtitle={subtitle}>
            {children}
          </EmptyList>
          <EmptyListInfo
            className="col-lg-4 col-xl-3 bg-light-2 px-5 py-3 bg-light"
            title={title}
            helpTitle={helpTitle}
            helpSubtitle={helpSubtitle}
            helpLinks={helpLinks}
            helpImage={helpImage}
          />
        </div>
      </div>
    </div>
  );
};
